import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import './FooterNavigation.module.css';

import FacebookIcon from 'Images/icon_facebook.png';
import InstagramIcon from 'Images/icon_instagram.png';


FooterNavigation.PropTypes = {
  data: PropTypes.object,
};

function FooterNavigation({ data }) {
  return (
    <nav styleName="FooterNavigation">
      <ul>
        <li>
          <a href={data.instagram}>
            <img src={InstagramIcon} alt="Instagram Icon" />
          </a>
          <a href={data.facebook}>
            <img src={FacebookIcon} alt="Facebook Icon" />
          </a>
        </li>
        <li styleName="agbLink">
          <Link to="agb">AGBs, Impressum & Datenschutz</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNavigation;


// WEBPACK FOOTER //
// ./src/components/Footer/FooterNavigation.js